import { Container, Row, Col, Carousel, Card, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import portugalkesse from '../../img/pm.png'
import portugal from '../../img/11.png'
import video from '../../img/video.mp4'
const Who=()=>{
    return(
        <section style={{ marginBottom: '11.875rem' }}>
        <Container>
          <Row>

            <Col lg={6}>
              <h2 className="text-center" style={{ position: 'relative', fontSize: '46px', display: 'inline-block' }}>
                <b>Who we are</b>
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: '0',
                  width: '50%', // Ajuste a largura do sublinhado para cobrir a parte desejada
                  height: '2px',
                  backgroundColor: '#ff5722' // Cor do sublinhado
                }} />
              </h2>
              <p>
              We are N.Wayami, a 100% Angolan company, offering strategic solutions that simplify,
               optimize, and add value to businesses. We operate in the areas of building maintenance,
                information technology,
               and consulting, always focusing on efficiency, innovation, and results. </p>



              <Link to="/OurTeam">
                <Button style={{ backgroundColor: '#FF5722', borderColor: '#FF5722', width: '115px', padding: '10px' }}>
                Learn more
                </Button>
              </Link>
            </Col>



            {/* Referências (lado esquerdo) */}
           
            <Col lg={6} style={{ height: 'auto' }}>
  <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
    <div style={{ position: 'relative' }}>
      <video
        style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
        controls
        poster={portugal}
      >
        <source src={video} type="video/mp4" />
        Your browser does not support the video element.
      </video>
    </div>
  </div>
</Col>
          </Row>  


        </Container>
        <div id='servicos'></div></section>
    )
}

export default Who;